import { useScrollTrigger } from '@mui/material';
import { CONSTANTS } from '../../../../constants/constants';
import NRSBOMVulnExploitsStyles from './NRSBOMVulnExploits.styles';
import { makeStyles } from '@mui/styles';
import { useContext, useEffect } from 'react';
import { DependencyDrawerTabsContext } from '../NRSBOMDrawer';
import NRColoredBarVulnerabilitiesContainer from '../../../../components/NRColoredBarVulnerabilitiesContainer/NRColoredBarVulnerabilitiesContainer';
import NRTitleWithRightTotal from '../../../../components/NRRightTotal/NRRightTotal';
import { FiltersContext } from '../../../NRReportTabs/NRReportFilterContextWrapper';
import { removeTabAndSubTabFromFilePath } from '../../../../services/urlInterceptor.utils';
import { useLocation, useNavigate } from 'react-router-dom';
import { encodeParam } from '../../../../services/params.utils';

const useStyles = makeStyles(NRSBOMVulnExploitsStyles);

const { TABS } = CONSTANTS.TABLE.SBOM_TABLE.SBOM_DETAIL_DRAWER;
const { EQUAL } = CONSTANTS.FILTER_OPERATIONS;

const NRSBOMVulnExploits = ({ dependency, threshold, scrollTarget, index, scrollableId }) => {
  const { setScrollSpyTabsValue } = useContext(DependencyDrawerTabsContext);
  const { setOpenDrawer } = useContext(FiltersContext);
  const navigate = useNavigate();
  const { critical, high, low, medium } = dependency?.analytic?.vulnerability;
  const totalVulns = critical + high + low + medium;
  const classes = useStyles();
  const location = useLocation();

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold,
    target: !!scrollTarget ? scrollTarget : undefined
  });

  useEffect(() => {
    setScrollSpyTabsValue(index, trigger);
  }, [trigger]);

  const handleTotalClick = () => {
    if (totalVulns === 0) return;
    let filterFields = [];
    if (!!dependency?.dependency?.name) {
      filterFields.push({
        fieldName: 'NAME',
        value: dependency?.dependency?.name,
        operation: EQUAL
      });
    }
    if (!!dependency?.dependency?.vendor) {
      filterFields.push({
        fieldName: 'VENDOR',
        value: dependency?.dependency?.vendor,
        operation: EQUAL
      });
    }
    if (!!dependency?.dependency?.version?.id) {
      filterFields.push({
        fieldName: 'VERSION',
        value: dependency?.dependency?.version?.id,
        operation: EQUAL
      });
    }
    let extraParams = new URLSearchParams();
    extraParams.append('vulnerabilityColumnFilter', encodeParam(filterFields));
    setOpenDrawer(false);
    navigate(`${removeTabAndSubTabFromFilePath(location)}/${CONSTANTS.REPORT.TABS.VULNERABILITIES}?${extraParams.toString()}`);
  };

  return (
    <>
      <div id={scrollableId} className={classes.mainContainer}>
        <div className={classes.content}>
          <NRTitleWithRightTotal title={TABS.VULNERABILITIES} totalCount={totalVulns} handleTotalClick={handleTotalClick} />
          <NRColoredBarVulnerabilitiesContainer
            values={dependency?.analytic?.vulnerability}
            name={dependency?.dependency?.name}
            version={dependency?.dependency?.version?.id}
            vendor={dependency?.dependency?.vendor}
            extraHandleOnClick={() => setOpenDrawer(false)}
            showTotal={false}
          />
        </div>
      </div>
    </>
  );
};
export default NRSBOMVulnExploits;
